typeof window !== 'undefined' ? window.crypto = { getRandomValues: require('polyfill-crypto.getrandomvalues') } : global.crypto = { getRandomValues: require('polyfill-crypto.getrandomvalues') }
import { v4 as uuid } from 'uuid'
import { EventManager } from '../event-manager.class'
import { BrowserCommunicator } from './BrowserCommunicator.class'
import { ITC_OP_TYPES } from './Op.enum'

export class BrowserTab {
  constructor(existsOtherTab) {
    this._changed = false
    this.events = new EventManager()
    const isNewAndMyTab = !existsOtherTab
    if (isNewAndMyTab) {
      this.isMyTab = true
      this.id = uuid()
      this._createdAt = new Date();
      this._modifiedAt = new Date();
      this._lastestSyncTime = new Date();      
      this.communicator = new BrowserCommunicator(this.id)
      this.communicator.events.addEventListener('message', (eventObject) => {
        this.events.dispatch('message', eventObject)
      })

      this._refreshDefaultInfo()
      this._initializeEvents()
      this.sync()
      if (!process.env.JEST_WORKER_ID) { 
        setInterval(() => {
          this.sync()
        }, 1000)
      }
    } else {
      this.isMyTab = false
      this.id = existsOtherTab.id
      this._createdAt = new Date(existsOtherTab.createdAt);
      this._modifiedAt = existsOtherTab.modifiedAt ? new Date(existsOtherTab.modifiedAt) : new Date();
      this._lastestSyncTime = new Date(existsOtherTab.latestSyncTime);
      this._info = existsOtherTab.info;
      this.communicator = new BrowserCommunicator(this.id)
    }

  }

  _initializeEvents() {
    this.events.addEventListener('hidden', (event) => {
      this.set('hidden', !!event.hidden)
      this.sync()
    })
    this.events.addEventListener('active', (event) => {
      this.sync()
      this.forceSync()
    })
  }

  set(key, value, ignoreUpdateTime) {
    if (!this._info) {
      this._info = {
        title: 'Initialized Tab Title',
        location: {}
      }
    }
    if (!ignoreUpdateTime) {
      this._modifiedAt = new Date()
      this._changed = true
    }
    this._info[key] = value
  }

  get(key) {
    return this._info && this._info[key]
  }

  get changed() {
    return this._changed
  }

  get createdAt() {
    return this._createdAt.getTime()
  }

  get modifiedAt() {
    return this._modifiedAt.getTime()
  }

  get latestSyncTime() {
    return this._lastestSyncTime && this._lastestSyncTime.getTime()
  }

  get info() {
    const data = {}
    const _info = JSON.parse(JSON.stringify(this._info || {}))
    data['id'] = this.id
    data['info'] = _info
    data['createdAt'] = this.createdAt
    data['modifiedAt'] = this.modifiedAt
    data['latestSyncTime'] = this.latestSyncTime
    data['changed'] = !!this.changed
    return data
  }

  set info(infoValue) {
    const newInfoValue = JSON.parse(JSON.stringify(infoValue || {}))
    this._info = newInfoValue
  }

  _refreshDefaultInfo() {
    if (typeof window === 'undefined') {
      return
    }
    this.set('title', window.document.title, true)
    this.set('location', JSON.parse(JSON.stringify(window.location)), true)
  }

  touch() {
    this._lastestSyncTime = new Date()
  }

  sync() {
    this._refreshDefaultInfo()
    this.touch()
    this.communicator.dispatch({
      type: ITC_OP_TYPES.SYNC,
      data: this.info
    })
    this._changed = false
  }

  forceSync() {
    this._refreshDefaultInfo()
    this.touch()
    this.communicator.dispatch({
      type: ITC_OP_TYPES.FORCE_SYNC,
      data: this.info
    })
  }

  sendToEval(_evalString, targetID) {
    this.communicator.dispatch({
      targetID: targetID,
      type: ITC_OP_TYPES.EVAL,
      data: _evalString
    })
  }
}

export default {
  BrowserTab
}
